<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">District</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="setHuntingPeriodDates">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Name</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input class="input" type="text" v-model="name" :disabled="isSaving" />
                </div>
              </div>
            </div>
          </div>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="error">
          {{ error }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancel" :disabled="isSaving">
              Cancel
            </button>
            <button class="button is-primary" @click="save" :disabled="isSaving">
              Save
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { SAVE_ANIMAL_DISTRICT } from '@/modules/animals/animalsStore'

export default {
  name: 'AnimalEditHuntingPeriodModal',

  props: {
    animalsStorePath: {
      type: String,
      required: true
    },

    animalDistrict: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      name: null,
      error: null,
      isSaving: false
    }
  },

  mounted() {
    this.name = this.animalDistrict.name
  },

  methods: {
    cancel() {
      this.$emit('cancelled')
    },

    async save() {
      if (!this.name || this.name.trim().length === 0) {
        this.error = 'Name is required'
        return
      }

      this.isSaving = true
      this.error = null

      const animalDistrict = { ...this.animalDistrict }
      animalDistrict.name = this.name

      try {
        const saveAnimalDistrictAction = `${this.animalsStorePath}/${SAVE_ANIMAL_DISTRICT}`
        await this.$store.dispatch(saveAnimalDistrictAction, {
          animalDistrict
        })

        this.$emit('succeeded')
      } catch (error) {
        this.error = error || 'Something went wrong.'
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
